import { createFileRoute } from '@tanstack/react-router'
import { NotificationSettingsPage } from '@/features/settings/components/notification-settings-page'

export const Route = createFileRoute(
  '/_app/_auth/dashboard/_layout/settings/notifications',
)({
  component: NotificationSettingsPage,
  beforeLoad: () => ({
    title: 'Notifications',
    headerTitleKey: 'header.settings.title',
    headerDescriptionKey: 'header.settings.description',
  }),
})
